import { render, staticRenderFns } from "./bank-data.vue?vue&type=template&id=313193a6&scoped=true&"
import script from "./bank-data.vue?vue&type=script&lang=ts&"
export * from "./bank-data.vue?vue&type=script&lang=ts&"
import style0 from "./bank-data.vue?vue&type=style&index=0&id=313193a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313193a6",
  null
  
)

export default component.exports